import React from 'react'
import ChatNow from '../chatnow'
const HowItWorks = () => {
    return (
        <div className='min-h-screen py-12 relative' id='howitworks'>
            <div className='container mx-auto p-3 mb-10'>
                <p className='text-center text-[#1E1E1E]'>How It Works</p>
                <h2 className='text-center text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>Get Connected With A Lawyer In Just
                    <span className='hidden md:inline-block mx-3'>3</span>
                    <span className='md:hidden mx-3'>2</span> Simple Steps</h2>
                <div className='flex max-md:flex-col justify-between items-center gap-6 mt-12'>
                    <div className='p-4 sm:max-w-[320px] max-md:flex max-md:flex-row-reverse justify-center gap-2'>
                        <img src='/assets/images/click.png' alt="" className='w-[100%] max-sm:w-[50%]' />
                        <div className=''>
                            <h2 className='text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>01.</h2>
                            <p className='text-[#1E1E1E]'>Click Chat Now</p>
                        </div>
                    </div>
                    <div className='hidden md:block'>
                        <div className=' p-4 sm:max-w-[320px] max-md:flex max-md:flex-row justify-center gap-2'>
                            <img src='/assets/images/think.png' alt="" className='w-[100%] max-sm:w-[50%]' />
                            <div>
                                <h2 className='text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>02.</h2>
                                <p className='text-[#1E1E1E]'>Select Area of law</p>
                            </div>
                        </div>
                    </div>
                    <div className='p-4 sm:max-w-[320px] max-md:flex max-md:flex-row justify-center gap-2'>
                        <img src='/assets/images/phone.png' alt="" className='w-[100%] max-sm:w-[50%]' />
                        <div>
                            <h2 className='hidden md:block text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>03.</h2>
                            <h2 className='md:hidden text-[#1E1E1E] text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>02.</h2>
                            <p className='text-[#1E1E1E] max-sm:max-w-[150px]'>connect with a lawyer</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='absolute max-sm:left-0 right-0 bottom-2 sm:right-14 p-4 mt-5'>
                <ChatNow text="Chat now!"/>
            </div>
        </div>
    )
}

export default HowItWorks
